/** @graphql cc **/

import gql from 'graphql-tag';

export const GetCurrentStorageUsageQuery = gql`
	query GetCurrentStorageUsageQuery {
		storage: confluence_storage {
			bytesUsed
			isStorageEnforcementGracePeriodComplete
			gracePeriodEndDate
		}
	}
`;
